import React, { FC } from 'react';

import { LoadingBar } from '../LoadingBar';
import { Spinner } from '../Spinner';
import * as S from './loading.styles';

export type LoadingProps = {
  isCustomMessage?: boolean;
  message?: string;
  name: string;
  percentage: number;
};

export const Loading: FC<LoadingProps> = ({
  isCustomMessage = false,
  message = '',
  name,
  percentage,
}) => {
  return (
    <S.Container>
      <S.LabelWrapper>
        <S.Label>{isCustomMessage ? message : `${name} is loading... please wait`}</S.Label>
        <Spinner type="orbit" />
      </S.LabelWrapper>
      <S.ProgressWrapper>
        <LoadingBar percentage={percentage} />
        <S.ProgressNumber>{`${percentage}%`}</S.ProgressNumber>
      </S.ProgressWrapper>
    </S.Container>
  );
};

export const LoadingBackground = S.Background;
